import React from 'react';
import { AppConfigEntity } from '../../types/AppConfigEntity';

const AppConfigContext = React.createContext<AppConfigEntity | null>(null);

export default AppConfigContext;
